<div class="p-6">
    <div class="text-center uppercase tracking-[0.25em] text-gray-400 text-sm font-semibold">
        {{ 'PACKAGES_PERSO_MANAGEMENT.CONFIRMATION' | translate }}
    </div>

    <p class="text-center text-gray-300 mt-4 mb-4">
        {{ isActivating ?
           ('PACKAGES_PERSO_MANAGEMENT.CONFIRM_ACTIVATE_PACKAGE' | translate) :
           ('PACKAGES_PERSO_MANAGEMENT.CONFIRM_DEACTIVATE_PACKAGE' | translate) }}
    </p>

    <div class="rounded-lg border border-gray-600 bg-black/20 mb-6">
        <span class="block px-4 py-3 text-white font-semibold">{{ packageName }}</span>
    </div>

    <div class="flex gap-3">
        <button type="button" (click)="onCancel()"
            class="flex-1 px-4 py-3 rounded-lg border border-gray-500 text-white font-medium hover:bg-white/5 transition-colors">
            {{ 'PACKAGES_PERSO_MANAGEMENT.CANCEL' | translate }}
        </button>
        <button type="button" (click)="onConfirm()"
            class="flex-1 px-4 py-3 rounded-lg bg-rougeNovo text-white font-semibold hover:bg-rougeNovoHover transition-colors">
            {{ isActivating ?
               ('PACKAGES_PERSO_MANAGEMENT.ACTIVATE' | translate) :
               ('PACKAGES_PERSO_MANAGEMENT.DEACTIVATE' | translate) }}
        </button>
    </div>
</div>
